import { Injectable } from '@angular/core';
import { select } from "@angular-redux/store";
import { Observable } from "rxjs/Observable";
import { combineLatest } from "rxjs/observable/combineLatest";
import { AdministrationUnit } from "../../../shared/view-model/organization/administration-unit.type";
import { touchMainMenu } from "./touch-navigation-menu/touch-main.menu";
import { VbMenuEntry } from "./menu-item.interface";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import * as _ from 'lodash';
import { IUser } from 'app/shared/redux-store/session/session.types';

@Injectable()
export class TouchMenuService {

  @select(['session', 'activeAdminUnit'])
  activeAdminUnitCuid$: Observable<string>;

  @select(['session', 'activeAdminUnitData'])
  activeAdminUnit$: Observable<AdministrationUnit>;

  @select(['session', 'user'])
  activeUser$: Observable<IUser>;

  private _menuEntries: VbMenuEntry[] = [];
  get menuEntries(): VbMenuEntry[] {
    return this._menuEntries;
  }

  set menuEntries(value: VbMenuEntry[]) {
    this._menuEntries = _.cloneDeep(value);
    this.activeMenuEntries$.next(this.getActiveButtons());
  }

  public activeMenuEntries$: BehaviorSubject<VbMenuEntry[]> = new BehaviorSubject<VbMenuEntry[]>([]);

  constructor() {

    this.menuEntries = touchMainMenu;

    combineLatest(this.activeAdminUnit$, this.activeUser$).subscribe(([au, user]) => {

      // Enable fill-up menu entry
      if (au.is_manager_of_external_depots) {
        const newMenu = _.cloneDeep(this.menuEntries);
        let b = newMenu.find(i => i.id == 'fill-up');
        b.visible = true;
        this.menuEntries = newMenu;
      }

      if (au.is_managed_by_external_admin_units) {
        const newMenu = _.cloneDeep(this.menuEntries);
        let b = newMenu.find(i => i.id == 'depot-needs');
        b.visible = true;
        this.menuEntries = newMenu;
      }

      // Enable vTouch menu entry
      if (au.cuid == 'citwjif1c0001m4t9pcygmekt' || au.cuid == 'citwjiiiw0001m4t9icogygfo') {
        const newMenu = _.cloneDeep(this.menuEntries);
        let b = newMenu.find(i => i.id == 'vtouch');
        b.visible = true;
        this.menuEntries = newMenu;
      }

      // Enable scan box
      if (user.roles?.includes('scanbox')) {
        const newMenu = _.cloneDeep(this.menuEntries);
        let b = newMenu.find(i => i.id == 'marriage');
        b.visible = true;
        this.menuEntries = [b];
      }

    });

  }

  getActiveButtons(): VbMenuEntry[] {
    const ab = _.cloneDeep(this.menuEntries);
    return ab.filter(b => b.visible === undefined || b.visible === true);
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/navigation/touch-menu.service.ts